module.exports = __webpack_public_path__ + "static/img/iconfont.91cd9a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1683809780211
// module id = VHLO
// module chunks = 44